import fetcher from 'modules/fetcher'

const fetchItem = (type, itemId) => {
  let url = ''
  switch (type) {
    case 'Person':
      url = `/api/v3/people/${itemId}`
      break
    case 'Company':
      url = `/api/v3/companies/${itemId}`
      break
    case 'Deal':
      url = `api/v3/deals/${itemId}`
      break
    case 'Project':
      url = `/api/v3/projects/${itemId}`
      break
    case 'ProjectMilestone':
      url = `/api/v3/project_milestones/${itemId}`
      break
  }
  return fetcher(url, {
    method: 'GET'
  })
}

const imageMissing = (resource) => !resource.image_thumb_url || /missing/.test(resource.image_thumb_url)

export { fetchItem, imageMissing }
